import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ReactionIcon from 'components/shared/ReactionIcon';
import ReactionResultsModal from 'components/shared/ReactionResultsModal';
import { IReactionSummary, REACTION_TYPE } from 'constants/types';

import { Stat, StatsContainer, StyledReactions } from './styles';

interface InteractionCounterProps {
  reactionSummary: IReactionSummary;
  commentsCount: number;
}

const InteractionCounter: React.FC<InteractionCounterProps> = ({
  reactionSummary,
  commentsCount,
}) => {
  const { t } = useTranslation('forum');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <StatsContainer>
      <StyledReactions>
        {reactionSummary.reactions.map((reaction) => (
          <React.Fragment key={reaction._id}>
            <ReactionIcon reactionType={reaction._id} />
          </React.Fragment>
        ))}
        <Stat onClick={showModal}>
          {reactionSummary.totalCount === 1
            ? t('like', { count: reactionSummary.totalCount })
            : t('likes', { count: reactionSummary.totalCount })}
        </Stat>
      </StyledReactions>

      {commentsCount > 0 && (
        <Stat>
          {commentsCount} {commentsCount === 1 ? t('comment') : t('comments')}
        </Stat>
      )}

      <ReactionResultsModal
        isVisible={isModalVisible}
        onClose={handleCancel}
        reactionSummary={reactionSummary}
      />
    </StatsContainer>
  );
};

export default InteractionCounter;
